import { render, staticRenderFns } from "./LanguageDropdown.vue?vue&type=template&id=62e40446&"
import script from "./LanguageDropdown.vue?vue&type=script&lang=ts&"
export * from "./LanguageDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageDropdown.vue?vue&type=style&index=0&id=62e40446&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports